<template>
    <Datepicker
        ref="dp"
        class="datepicker__common"
        v-model="date"
        model-type="dd/MM/yyyy"
        :hide-navigation="['time', 'seconds']"
        :max-date="maxDate"
        :min-date="minDate"
        :locale="$store.state.lang"
    >
        <template #trigger>
            <button class="datepicker__button">
                <img class="datepicker__button-icon" :src="require(`@/public/img/${$store.state.config.skin}/calendar.png`)" alt="calendar" />
                <span v-if="isStrEmpty()">
                    {{ getTranslatedText(buttonText) }}
                </span>
                <span v-else>{{ date }}</span>
            </button>
        </template>
        <template #action-buttons>
            <div class="dp__action_buttons">
                <button type="button" class="dp__action_button dp__action_cancel" @click="onClickCloseMenu">{{ getTranslatedText('close') }}</button>
                <button type="button" class="dp__action_button dp__action_select" @click="onClickSelectDate">
                    {{ getTranslatedText('confirm') }}
                </button>
            </div>
        </template>
    </Datepicker>
</template>

<script>
import utilsMixin from '@/mixins/function-utils';

import Datepicker from '@vuepic/vue-datepicker';
import languageMixins from '@/mixins/language-mixins';

import '@vuepic/vue-datepicker/dist/main.css';
import EventBus from '@/utils/EventBus';
import { isStrEmpty } from '@/utils/utils';

export default {
    mixins: [utilsMixin, languageMixins],
    props: {
        keyItem: {
            type: String,
            default: '',
        },
        buttonText: {
            type: String,
            default: '',
        },
        maxDate: {
            type: String,
            default: '',
        },
        minDate: {
            type: String,
            default: '',
        },
        nameFunction: {
            type: String,
            default: 'on-select-datepicker',
        },
    },
    components: {
        Datepicker,
    },
    data() {
        return {
            date: '',
        };
    },
    watch: {
        date(newDate, oldDate) {
            if (!isStrEmpty(newDate) && newDate !== oldDate) {
                const [day, month, year] = newDate.split('/');
                const date = `${year}-${month}-${day}`;
                const param = {
                    key: this.keyItem,
                    date,
                };
                EventBus.emit(this.nameFunction, param);
            }
        },
    },
    created() {
        EventBus.on('on-clear-filter-date', () => {
            this.date = '';
        });
    },
    unmounted() {
        EventBus.off('on-clear-filter-date');
    },
    methods: {
        onClickSelectDate() {
            this.$refs.dp.selectDate();
        },
        onClickCloseMenu() {
            this.$refs.dp.closeMenu();
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/common/calendar.scss';
</style>
